import { render, staticRenderFns } from "./JournalMetaData.vue?vue&type=template&id=e8eac63a"
import script from "./JournalMetaData.vue?vue&type=script&lang=js"
export * from "./JournalMetaData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports